import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollSalaryItem  {
    _originalTypeClassName = "zERP.BO.PayrollSalaryItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollSalaryItem.translate = translateService;
}
this.Code = null;
this.SalaryAmount = null;
this.ContributionAmount = null;
this.TaxAmount = null;
this.PayrollSalaryItemKey = null;
this._key = this.PayrollSalaryItemKey = 0; 
}

static translate: TranslateService;
_key: any;
Code:any;
SalaryAmount:any;
ContributionAmount:any;
TaxAmount:any;
private _PayrollSalaryItemKey:any;
get PayrollSalaryItemKey(): any {
    return this._PayrollSalaryItemKey;
  }
set PayrollSalaryItemKey(value: any) {
    this._PayrollSalaryItemKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollSalaryItemKey == null || $this.PayrollSalaryItemKey == 0;
            }


}